<template>
  <div class="left-aligned-form">
    <div class="title">
      <h3>返厂维修详情</h3>
    </div>
    <el-form ref="phoneForm" :model="phoneForm" label-width="125px">
      <el-form-item label="手机品牌:" v-show="this.phoneForm.phoneBrand">
        <el-input v-model="phoneForm.phoneBrand" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="型号:" v-show="this.phoneForm.phoneName">
        <el-input v-model="phoneForm.phoneName" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="颜色:" v-show="this.phoneForm.phoneColor">
        <el-input v-model="phoneForm.phoneColor" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="内存:" v-show="this.phoneForm.phoneMemory">
        <el-input v-model="phoneForm.phoneMemory" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="序列号:" v-show="this.phoneForm.SNName">
        <el-input v-model="phoneForm.SNName" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="IMEI:" v-show="this.phoneForm.IMEIName">
        <el-input v-model="phoneForm.IMEIName" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="IMEI2:" v-show="this.phoneForm.IMEI2Name">
        <el-input v-model="phoneForm.IMEI2Name" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <!-- <el-form-item label="正面图:" v-show="this.phoneForm.screenURL">
        <el-image :preview-src-list="[phoneForm.screenURL]" style="width: 160px; height: 200px; cursor: pointer"
          :src="phoneForm.screenURL">
        </el-image>
      </el-form-item>
      <el-form-item label="正面图备注:" v-show="this.phoneForm.screenText">
        <el-input v-model="phoneForm.screenText" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="背板图:" v-show="this.phoneForm.bankURL">
        <el-image style="width: 160px; height: 200px; cursor: pointer" :src="phoneForm.bankURL"
          :preview-src-list="[phoneForm.bankURL]"></el-image>
      </el-form-item>
      <el-form-item label="背板图备注:" v-show="this.phoneForm.bankText">
        <el-input v-model="phoneForm.bankText" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="左侧图:" v-show="this.phoneForm.leftURL">
        <el-image style="width: 160px; height: 200px; cursor: pointer" :preview-src-list="[phoneForm.leftURL]"
          :src="phoneForm.leftURL"></el-image>
      </el-form-item>
      <el-form-item label="左侧图备注:" v-show="this.phoneForm.leftText">
        <el-input v-model="phoneForm.leftText" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="右侧图:" v-show="this.phoneForm.rightURL">
        <el-image style="width: 160px; height: 200px; cursor: pointer" :preview-src-list="[phoneForm.rightURL]"
          :src="phoneForm.rightURL"></el-image>
      </el-form-item>
      <el-form-item label="右侧图备注:" v-show="this.phoneForm.rightText">
        <el-input v-model="phoneForm.rightText" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="顶部图:" v-show="this.phoneForm.topURL">
        <el-image style="width: 160px; height: 200px; cursor: pointer" :preview-src-list="[phoneForm.topURL]"
          :src="phoneForm.topURL"></el-image>
      </el-form-item>
      <el-form-item label="顶部图备注:" v-show="this.phoneForm.topText">
        <el-input v-model="phoneForm.topText" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="尾插图:" v-show="this.phoneForm.bottomURL">
        <el-image style="width: 160px; height: 200px; cursor: pointer" :preview-src-list="[phoneForm.bottomURL]"
          :src="phoneForm.bottomURL"></el-image>
      </el-form-item>
      <el-form-item label="尾插图备注:" v-show="this.phoneForm.bottomText">
        <el-input v-model="phoneForm.bottomText" style="width: 220px" :disabled="true"></el-input>
      </el-form-item> -->
      <el-form-item label="自定义图片1:" v-show="this.phoneForm.custom1URL">
        <el-image style="width: 160px; height: 200px; cursor: pointer" :preview-src-list="[phoneForm.custom1URL]"
          :src="phoneForm.custom1URL"></el-image>
      </el-form-item>
      <el-form-item label="自定义图片1备注:" v-show="this.phoneForm.custom1Text">
        <el-input v-model="phoneForm.custom1Text" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="自定义图片2:" v-show="this.phoneForm.custom2URL">
        <el-image style="width: 160px; height: 200px; cursor: pointer" :preview-src-list="[phoneForm.custom2URL]"
          :src="phoneForm.custom2URL"></el-image>
      </el-form-item>
      <el-form-item label="自定义图片2备注:" v-show="this.phoneForm.custom2Text">
        <el-input v-model="phoneForm.custom2Text" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="自定义图片3:" v-show="this.phoneForm.custom3URL">
        <el-image style="width: 160px; height: 200px; cursor: pointer" :preview-src-list="[phoneForm.custom3URL]"
          :src="phoneForm.custom3URL"></el-image>
      </el-form-item>
      <el-form-item label="自定义图片3备注:" v-show="this.phoneForm.custom3Text">
        <el-input v-model="phoneForm.custom3Text" style="width: 220px" :disabled="true"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      phoneForm: {},
      userId: "",
    };
  },
  created() {
    const queryID = this.$route.params.id;
    console.log(queryID, "queryID");
    this.userId = this.$route.query.userId;
    this.getReturnDetail(queryID);
  },
  methods: {
    getReturnDetail(id) {
      var that = this;
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const orderListApiInstance = axios.create({
        baseURL: "/orderListApi",
        headers: {
          "Content-Type": "application/json",
        },
      });
      let params = {
        userId: this.userId,
        imei:id,
      }
      //使用FormData对象发送POST请求
      orderListApiInstance
        .post("monkeyshop/common/findRepairDetailByImei", params)
        .then((res) => {
          console.log(res, "res");
          let detailData = res.data.data.afterSalesReq;
          console.log("detailData:",detailData)
          that.$set(
              that.phoneForm,
              "phoneBrand",
              detailData.phoneBrand
            );
            that.$set(
              that.phoneForm,
              "phoneName",
              detailData.phoneModel
            );
            that.$set(
              that.phoneForm,
              "phoneColor",
              detailData.phoneColor
            );
            that.$set(
              that.phoneForm,
              "IMEIName",
              detailData.imei
            );
            that.$set(
              that.phoneForm,
              "IMEI2Name",
              detailData.imei2
            );
            that.$set(
              that.phoneForm,
              "custom1URL",
              detailData.custom1Data
            );
            that.$set(
              that.phoneForm,
              "custom1Text",
              detailData.custom1picText
            );

            that.$set(
              that.phoneForm,
              "custom2URL",
              detailData.custom2Data
            );
            that.$set(
              that.phoneForm,
              "custom2Text",
              detailData.custom2picText
            );
            that.$set(
              that.phoneForm,
              "custom3URL",
              detailData.custom3Data
            );
            that.$set(
              that.phoneForm,
              "custom3Text",
              detailData.custom3picText
            );
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.left-aligned-form {
  text-align: left;
  padding: 10px 0px 10px 0px;
}

.title {
  margin: 10px 10px 20px 10px;
}
</style>


// WEBPACK FOOTER //
// src/views/depotRepairQueryPage.vue